<template>
  <div class="offer container" :class="offerGlobalClass">
    <div class="offer-header row">
      <div class="col-4 offer-title">
        <img class="exclusive-logo" alt="Exclusive School" src="../assets/exclusive_icon.png" v-if="showExclusiveLogo"> <img class="exclusive-logo" alt="New School" src="../assets/new_offer_icon.png" v-if="showNewLogo"> {{name}}
      </div>
      <div class="col-5 text-center header-center"><img alt="Online School" src="../assets/online_icon.png" v-if="isOnline"><img alt="Campus School" src="../assets/campus_icon.png" v-if="isCampus"></div>
      <div class="col-3 d-flex flex-row-reverse button-area"><button class="btn btn-danger skip-button" @click="skip()">Skip</button><button class="btn btn-light show-button" @click="show" v-show="!showForm" :disabled="!isEnabled">Show</button></div>
      <div class="col-12" v-if="similarSubmitted || similarPending || expired || failedPing">
        <div class="row warning-row">
          <div class="duplicate-message col-12" v-if="similarSubmitted || similarPending">A similar offer has already been submitted.</div>
          <div class="timeout-message col-12" v-else-if="expired">{{expireMessage}}</div>
          <div class="timeout-message col-12" v-else-if="failedPing">This offer has failed additional scoring.</div>
        </div>
      </div>
    </div>
    <div class="offer-form" v-if="showLoading">
      <div class="loading text-center">
        <br /><img :src="loadingImg" />
      </div>
    </div>
    <div class="offer-form" v-if="!showLoading">
      <div class="row aos-row" v-if="subjects && subjects.length > 0">
        <div class="col-auto aos-title">Area of Study(s) Available:</div>
        <div class="col-auto offer-subject" v-for="subject in subjects" :key="subject.id">{{subject.name}}</div>
      </div>
      <div class="small-top row">
        <div class="col-4 col-lg-3 col-xl-2"><img class="offer-logo" :src="offer.logoURL" :alt="name" /></div>
        <div class="col-8 col-lg-9 col-xl-10">
          <div class="short-description" v-html="shortDescription">
          </div>
          <div class="view-more" @click="toggleModal">View More</div>
        </div>
      </div>
      <div class="offer-form" v-if="showForm">
        <component class="row" v-for="field in normalFields"
        :is="field.fieldComponent"
        :form-field="field"
        :model-value="formResponses[field.element_id]"
        @update:model-value="setFieldValue(field.element_id, $event)"
        :current-program="programField ? formResponses[programField.element_id] : null"
        :current-campus="campusField ? formResponses[campusField.element_id] : null"
        :offer-enabled="isEnabled"
        :program-search="programSearch"
        :errors="formErrors[field.element_id]"
        :subjects="subjects"
        :key="field.element_id"
        :consumer-id="currentConsumerId">
        </component>
        <div class="first-submit row justify-content-center" v-show="submitStep < 3">
          <div class="col-auto">
            <button class="btn btn-primary" @click="submitStep1" v-show="submitStep === 1" :disabled="!isEnabled">{{useBulkSubmission ? 'Select' : 'Submit'}}!</button>
            <button class="btn btn-success" @click="submitStep2" v-show="submitStep === 2" :disabled="!isEnabled">
              <span class="fw-bold">></span> If TCPA is Confirmed<span v-if="offer.isWt"> & Has 10 - 15 mins</span>,<br />
              <span class="fw-bold">CLICK HERE</span>
              </button>
          </div>
        </div>
        <WtBulkSubmitOverlay :open="openWtSubmit" :loading-questions="fetchingWtInfo" @submitOffers="submitStep3" :offer="offer" @exitNoSubmit="closeWtSubmit">
          <template v-if="openWtSubmit">
            <WarmTransferPhoneNumber
              class="row"
              :current-program="programField ? formResponses[programField.element_id] : null"
              :current-campus="campusField ? formResponses[campusField.element_id] : null"
              :campaign-id="offer.campaignId"
              :offer-enabled="isEnabled"
              :external-phone-number="fetchedWtPhone"
              v-if="fetchedWtPhone || !offer.isExternalApi"
            ></WarmTransferPhoneNumber>
            <WarmTransferScript class="row" :transfer-script="transferScript" :program-name="currentProgramName" :campus-name="currentCampusName" :offer-name="name" v-if="transferScript"></WarmTransferScript>
            <component class="row" v-for="field in warmTransferFields"
              :is="field.fieldComponent"
              :form-field="field"
              :model-value="formResponses[field.element_id]"
              @update:model-value="setFieldValue(field.element_id, $event)"
              :current-program="programField ? formResponses[programField.element_id] : null"
              :current-campus="campusField ? formResponses[campusField.element_id] : null"
              :offer-enabled="isEnabled"
              :campaign-id="offer.campaignId"
              :errors="formErrors[field.element_id]"
              :key="field.element_id"
              :consumer-id="currentConsumerId">
            </component>
            <div class="wt-info-loading text-center" v-if="fetchingWtInfo">
              <img :src="loadingImg" />
            </div>
          </template>
        </WtBulkSubmitOverlay>
        <template v-if="submitStep > 2">
          <div class="wt-header row">
            <div class="col-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
              </svg>
            </div>
            <div class="col-8"><div class="row justify-content-center wt-title"><div class="col-auto">Warm Transfer Details</div></div></div>
            <div class="col-2 text-end">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
              </svg>
            </div>
          </div>
          <div class="wt-info-loading text-center" v-if="fetchingWtInfo">
            <img :src="loadingImg" />
          </div>
          <WarmTransferPhoneNumber
            class="row"
            :current-program="programField ? formResponses[programField.element_id] : null"
            :current-campus="campusField ? formResponses[campusField.element_id] : null"
            :campaign-id="offer.campaignId"
            :offer-enabled="isEnabled"
            :external-phone-number="fetchedWtPhone"
            v-if="fetchedWtPhone || !offer.isExternalApi"
          ></WarmTransferPhoneNumber>
          <WarmTransferScript class="row" :transfer-script="transferScript" :program-name="currentProgramName" :campus-name="currentCampusName" :offer-name="name" v-if="transferScript"></WarmTransferScript>
          <component class="row" v-for="field in warmTransferFields"
            :is="field.fieldComponent"
            :form-field="field"
            :model-value="formResponses[field.element_id]"
            @update:model-value="setFieldValue(field.element_id, $event)"
            :current-program="programField ? formResponses[programField.element_id] : null"
            :current-campus="campusField ? formResponses[campusField.element_id] : null"
            :offer-enabled="isEnabled"
            :campaign-id="offer.campaignId"
            :errors="formErrors[field.element_id]"
            :key="field.element_id"
            :consumer-id="currentConsumerId">
          </component>
          <div class="second-submit row justify-content-center">
            <div class="col-auto">
              <button class="btn btn-success" @click="submitStep3" :disabled="!isEnabled">
                <span class="fw-bold">></span> If Script has been read,<br />
                <span class="fw-bold">CLICK HERE</span>
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="modalId+'label'" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="modalId+'label'">{{name}}</h5>
            <div class="close-modal-x" @click="toggleModal">x</div>
          </div>
          <div class="modal-body">
              <div class="long-description" v-html="longDescription"></div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="toggleModal">Close</button>
          </div>
        </div>
    </div>
  </div>
  <div class="d-flex flex-row-reverse">
    <div class="col-auto offer-id-info">Offer ID: {{offer.id}}</div>
  </div>
  </div>
</template>
<script>
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import { nextTick } from 'vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import fetchPortalJson from '../js/PortalFetchJson'
import PortalPostJson from '@/js/PortalPostJson'
import AgeDropDown from './offer-form-elements/AgeDropDown.vue'
import CampusDropDown from './offer-form-elements/CampusDropDown.vue'
import Checkbox from './offer-form-elements/Checkbox.vue'
import CountryDropDown from './offer-form-elements/CountryDropDown.vue'
import DateFields from './offer-form-elements/DateFields.vue'
import DatePicker from './offer-form-elements/DatePicker.vue'
import DobFields from './offer-form-elements/DobFields.vue'
import GenericDropDown from './offer-form-elements/GenericDropDown.vue'
import GenericRadioList from './offer-form-elements/GenericRadioList.vue'
import HiddenField from './offer-form-elements/HiddenField.vue'
import PhoneField from './offer-form-elements/PhoneField.vue'
import ProgramDropDown from './offer-form-elements/ProgramDropDown.vue'
import OnlyLabel from './offer-form-elements/OnlyLabel.vue'
import OnlyLabelAndValue from './offer-form-elements/OnlyLabelAndValue.vue'
import StateDropDown from './offer-form-elements/StateDropDown.vue'
import TextField from './offer-form-elements/TextField.vue'
import WarmTransferAgentDropDown from './offer-form-elements/WarmTransferAgentDropDown.vue'
import WarmTransferPhoneNumber from './offer-form-elements/WarmTransferPhoneNumber.vue'
import WarmTransferScript from './offer-form-elements/WarmTransferScript.vue'
import WtBulkSubmitOverlay from './WtBulkSubmitOverlay.vue'

export default {
  name: 'Offer',
  props: ['offer', 'showForm', 'similarSubmitted', 'similarPending', 'pendingSubmits', 'programSearch', 'wait', 'showIndex'],
  components: {
    AgeDropDown,
    CampusDropDown,
    Checkbox,
    CountryDropDown,
    DateFields,
    DatePicker,
    DobFields,
    GenericDropDown,
    GenericRadioList,
    HiddenField,
    PhoneField,
    ProgramDropDown,
    OnlyLabel,
    OnlyLabelAndValue,
    StateDropDown,
    TextField,
    WarmTransferAgentDropDown,
    WarmTransferPhoneNumber,
    WarmTransferScript,
    WtBulkSubmitOverlay
  },
  emits: ['skip', 'show', 'submitOffer'],
  data () {
    return {
      viewMore: false,
      modal: null,
      formFields: [],
      formResponses: {},
      formErrors: {},
      submitStep: 1,
      currentTime: Date.now(),
      fetchedWtFields: [],
      fetchedWtPhone: null,
      fetchedWtScript: null,
      fetchingWtInfo: false,
      requestLogId: null,
      wtRequestLogId: null,
      openWtSubmit: false,
      openBulkSubmit: false,
      showLoading: false,
      failedPing: false,
      loadingImg: process.env.BASE_URL + 'loading.gif'
    }
  },
  computed: {
    currentConsumerId () {
      return this.consumerId
    },
    name () {
      return this.offer.name
    },
    shortDescription () {
      return this.offer.shortDescription
    },
    longDescription () {
      return this.offer.longDescription
    },
    subjects () {
      return this.offer.subjects
    },
    expired () {
      return this.offer.expiresAt && this.currentTime > this.offer.expiresAt
    },
    expireMessage () {
      return this.expired && this.offer.newOffer ? 'This offer has timed out.' : 'This offer has timed out and will automatically be refreshed.'
    },
    exclusive () {
      return this.offer.exclusive
    },
    showExclusiveLogo () {
      return this.offer.exclusive && !this.offer.isWt
    },
    showNewLogo () {
      return this.offer.newOffer && !this.showExclusiveLogo
    },
    isEnabled () {
      return !this.failedPing && !this.similarSubmitted && !this.similarPending && !this.expired && !this.wait && (!this.exclusive || (this.exclusive && (!this.waitForOfferSubmit && this.successfulSubmits.length === 0 && this.pendingSubmits.length === 0)))
    },
    modalId () {
      return `modal${this.offer.displayedOfferId ?? this.offer.id}`
    },
    isOnline () {
      return this.findCampusType(1)
    },
    isCampus () {
      return this.findCampusType(2)
    },
    programField () {
      return this.formFields.find((field) => field.fieldComponent === 'ProgramDropDown' && field.model === 'lead_education')
    },
    campusField () {
      return this.formFields.find((field) => field.fieldComponent === 'CampusDropDown' && field.model === 'lead_education')
    },
    currentProgramName () {
      return this.programField ? this.programField.formListItems.find((fli) => fli.id === this.formResponses[this.programField.element_id]).name : null
    },
    currentCampusName () {
      return this.campusField ? this.campusField.formListItems.find((fli) => fli.id === this.formResponses[this.campusField.element_id]).name : null
    },
    normalFields () {
      var specialFieldComponents = ['WarmTransferAgentDropDown']
      return this.formFields.filter((field) => !specialFieldComponents.includes(field.fieldComponent))
    },
    warmTransferFields () {
      var wtFieldComponents = ['WarmTransferAgentDropDown']
      return [...this.formFields.filter((field) => wtFieldComponents.includes(field.fieldComponent)), ...this.fetchedWtFields]
    },
    offerGlobalClass () {
      var highlight = false
      if (this.programSearch) {
        var search = this.programSearch.toUpperCase()
        highlight = this.offer.programs.some((program) => program.name.toUpperCase().includes(search))
      }
      var priority_offer = this.offer.priority
      var deactivated = !this.isEnabled
      return {
        highlight,
        deactivated,
        priority_offer
      }
    },
    transferScript () {
      var script = this.offer.isWt ? this.offer.wtScript ? this.offer.wtScript : this.fetchedWtScript : null

      return script
    },
    successfulSubmits () {
      return [...this.previousSubmits.filter((submit) => submit.status === 'Accepted' && submit.externalNameId).map((submit) => submit.externalNameId)]
    },
    ...mapState({
      consumerId: state => state.consumer.consumerId,
      waitForOfferSubmit: state => state.consumer.leadRequests.waitForOfferSubmit
    }),
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo',
      previousSubmits: 'consumer/leadRequests/getRequests',
      useBulkSubmission: 'consumer/useBulkSubmission'
    })
  },
  methods: {
    ...mapMutations({
      addPendingLeadRequest: 'consumer/leadRequests/addPendingLeadRequest'
    }),
    toggleModal () {
      if (this.isEnabled) {
        this.modal.toggle()
      }
    },
    show () {
      this.$emit('show')
    },
    skip (reason = null) {
      this.$emit('skip', reason)
    },
    findCampusType (type) {
      if (this.offer.campuses) {
        var campusCount = this.offer.campuses.length
        for (let cIndex = 0; cIndex < campusCount; cIndex++) {
          var campus = this.offer.campuses[cIndex]
          if (campus.school_type_id === type) {
            return true
          }
        }
      }
      return false
    },
    async getFormDetails () {
      var formResponse = await fetchPortalJson(`consumers/${this.consumerId}/forms/${this.offer.formId}`)
      if (formResponse.form_fields) {
        this.processFormFields(formResponse.form_fields, formResponse.form_list_items)
      }
    },
    async getExternalWtDetails () {
      this.fetchingWtInfo = true
      var requestString = `campaign_id=${this.offer.campaignId}&request_log_id=${this.requestLogId}`
      var vue = this
      this.formFields.forEach((field) => {
        var fieldValue = vue.formResponses[field.element_id]
        requestString += `&fields[${field.model}][${field.name}]=${fieldValue}`
      })
      var wtResponse = await fetchPortalJson('warm_transfer_infos?' + requestString)
      this.fetchedWtScript = wtResponse.warm_transfer_info.script
      this.fetchedWtPhone = wtResponse.warm_transfer_info.phone_number
      if (wtResponse.form_fields) {
        this.processFormFields(wtResponse.form_fields, wtResponse.form_list_items, true)
      }
      this.fetchingWtInfo = false
    },
    processFormFields (formFields, formListItems, isWtFields = false) {
      var fields = []
      formFields.forEach((fieldInfo) => {
        var field = this.setupFormListItems({ ...fieldInfo }, formListItems, isWtFields)
        fields.push(field)
        if (fieldInfo.name === 'request_log_id') {
          this.requestLogId = fieldInfo.prefilled_value
        }
        if (fieldInfo.name === 'wt_request_log_id') {
          this.wtRequestLogId = fieldInfo.prefilled_value
        }
      })
      if (isWtFields) {
        this.fetchedWtFields = fields.sort((field1, field2) => field1.sequence - field2.sequence)
      } else {
        this.formFields = fields.sort((field1, field2) => field1.sequence - field2.sequence)
      }
    },
    setupFormListItems (field, rootFormListItems, isWtFields = false) {
      if (field.form_list_items && field.form_list_items.length > 0) {
        field.formListItems = field.form_list_items
      } else if (field.form_list_item_ids && field.form_list_item_ids.length > 0) {
        field.formListItems = field.form_list_item_ids.map((id) => rootFormListItems.find((item) => item.id === id))
      }
      if (field.prefilled_value && (field.form_field_type_name === 'pf-only-label-text-with-value' || field.name !== 'tcpa_consent')) { // Don't prefill TCPA values
        this.setFieldValue(field.element_id, field.prefilled_value)
      }
      if (isWtFields && field.form_field_type_name === 'pf-generic-dropdown') {
        const sortAlphabetical = (a, b) => {
          var nameA = a.display ? a.display.toUpperCase() : ''
          var nameB = b.display ? b.display.toUpperCase() : ''
          return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
        }
        field.formListItems = field.formListItems.sort(sortAlphabetical)
      }
      field.responseRequired = true
      switch (field.form_field_type_name) {
        case 'pf-age-dropdown':
          field.fieldComponent = 'AgeDropDown'
          break
        case 'pf-campus-dropdown':
          field.fieldComponent = 'CampusDropDown'
          field.formListItems = this.offer.campuses
          break
        case 'pf-checkbox':
          field.fieldComponent = 'Checkbox'
          break
        case 'pf-country-dropdown':
          field.fieldComponent = 'CountryDropDown'
          break
        case 'pf-date-fields':
          field.fieldComponent = 'DateFields'
          break
        case 'pf-date-picker':
          field.fieldComponent = 'DatePicker'
          break
        case 'pf-dob-fields':
          field.fieldComponent = 'DobFields'
          break
        case 'pf-generic-dropdown':
          field.fieldComponent = 'GenericDropDown'
          break
        case 'pf-generic-list-with-radio':
          field.fieldComponent = 'GenericRadioList'
          break
        case 'pf-hidden-field':
          field.fieldComponent = 'HiddenField'
          field.responseRequired = false
          break
        case 'pf-only-label-text':
          field.fieldComponent = 'OnlyLabel'
          field.responseRequired = false
          break
        case 'pf-only-label-text-with-value':
          field.fieldComponent = 'OnlyLabelAndValue'
          field.responseRequired = false
          break
        case 'pf-phone-field':
          field.fieldComponent = 'PhoneField'
          break
        case 'pf-program-dropdown':
          field.fieldComponent = 'ProgramDropDown'
          field.formListItems = this.offer.programs
          break
        case 'pf-state-dropdown':
          field.fieldComponent = 'StateDropDown'
          break
        case 'pf-text-field':
          field.fieldComponent = 'TextField'
          break
        case 'pf-warm-transfer-agent-dropdown':
          field.fieldComponent = 'WarmTransferAgentDropDown'
          break
        case 'pf-year-dropdown':
          field.fieldComponent = 'YearDropDown'
          break
        default:
          field.fieldComponent = 'GenericDropDown'
          break
      }
      return field
    },
    setFieldValue (fieldId, value) {
      this.formResponses[fieldId] = value
      var errors = this.formErrors
      delete errors[fieldId]
      this.formErrors = errors
    },
    fieldsReady () {
      var fields
      if (this.programField) {
        var currentProgram = this.formResponses[this.programField.element_id]
        fields = this.normalFields.filter((field) => !field.program_ids || field.program_ids.length === 0 || (currentProgram && field.program_ids.includes(currentProgram)))
      } else {
        fields = this.normalFields
      }
      var errors = {}
      fields.forEach((field) => {
        if (!this.formResponses[field.element_id] && this.formResponses[field.element_id] !== false && field.responseRequired) {
          errors[field.element_id] = 'is required'
        }
      })
      this.formErrors = errors
      if (this.fetchingWtInfo) {
        return false
      }
      return Object.keys(errors).length === 0
    },
    wtFieldsReady () {
      var fields
      if (this.programField) {
        var currentProgram = this.formResponses[this.programField.element_id]
        fields = this.warmTransferFields.filter((field) => !field.program_ids || field.program_ids.length === 0 || field.program_ids.includes(currentProgram))
      } else {
        fields = this.warmTransferFields
      }
      var errors = {}
      fields.forEach((field) => {
        if (!this.formResponses[field.element_id] && this.formResponses[field.element_id] !== false && field.responseRequired) {
          errors[field.element_id] = 'is required'
        }
      })
      this.formErrors = errors
      return Object.keys(errors).length === 0
    },
    submitStep1 () {
      if (this.fieldsReady()) {
        if (this.useBulkSubmission) {
          this.submitStep2()
        } else {
          this.submitStep = 2
        }
      }
    },
    submitStep2 () {
      if (!this.fieldsReady()) {
        return
      }
      if (this.offer.isWt) {
        if (this.offer.isExternalApi) {
          this.getExternalWtDetails()
        }
        if (this.useBulkSubmission) {
          this.addPendingLeadRequest(this.finalRequestObject())
          this.openWtSubmit = true
        } else {
          this.submitStep = 3
        }
      } else if (this.offer.exclusive) {
        if (this.useBulkSubmission) {
          this.openBulkSubmit = true
          this.submitOffer()
        } else {
          this.submitOffer()
        }
      } else {
        this.submitOffer()
      }
    },
    submitStep3 () {
      if (this.wtFieldsReady()) {
        this.submitOffer()
      }
    },
    async submitOffer () {
      if (!this.fieldsReady()) {
        return
      }
      if (this.openWtSubmit) {
        this.openWtSubmit = false
        await nextTick()
      }
      if (this.openBulkSubmit) {
        this.openBulkSubmit = false
      }
      var finalRequest = this.finalRequestObject()
      this.$emit('submitOffer', finalRequest)
    },
    finalRequestObject () {
      var vue = this
      var submitObject = {}
      var allFields = this.offer.isWt && this.offer.isExternalApi ? [...this.formFields, ...this.fetchedWtFields] : this.formFields
      allFields.forEach((field) => {
        var fieldValue = vue.formResponses[field.element_id]
        if (!submitObject[field.model]) {
          submitObject[field.model] = {}
        }
        submitObject[field.model][field.name] = fieldValue
      })
      if (this.offer.displayedOfferId) {
        if (!submitObject.lead_custom_value) {
          submitObject.lead_custom_value = {}
        }
        submitObject.lead_custom_value.displayed_offer_id = this.offer.displayedOfferId
      }
      var finalRequest = { leadRequest: { raw_request: submitObject, campaign_id: this.offer.campaignId }, offer: this.offer }
      if (this.offer.offerExternalInfoId) {
        finalRequest.leadRequest.offer_external_info_id = this.offer.offerExternalInfoId
      }
      if (this.requestLogId) {
        finalRequest.leadRequest.request_log_id = this.requestLogId
      }
      if (this.wtRequestLogId) {
        finalRequest.leadRequest.wt_request_log_id = this.wtRequestLogId
      }
      return finalRequest
    },
    async initModal () {
      await new Promise((resolve) => setTimeout(resolve, 200))
      if (!this.similarSubmitted) {
        this.modal = new bootstrap.Modal(document.getElementById(this.modalId))
      }
    },
    closeWtSubmit () {
      this.openWtSubmit = false
    },
    closeBulkSubmit () {
      this.openBulkSubmit = false
    },
    triggerPrePingCheck () {
      if (this.showForm && this.offer.pingOnShow) {
        this.showLoading = true
        this.callPrePing()
      }
    },
    async callPrePing () {
      var vue = this
      var submitObject = {}
      this.formFields.forEach((field) => {
        var fieldValue = vue.formResponses[field.element_id]
        if (!submitObject[field.model]) {
          submitObject[field.model] = {}
        }
        submitObject[field.model][field.name] = fieldValue
      })
      if (this.offer.displayedOfferId) {
        if (!submitObject.lead_custom_value) {
          submitObject.lead_custom_value = {}
        }
        submitObject.lead_custom_value.displayed_offer_id = this.offer.displayedOfferId
      }
      if (submitObject.lead_education.program_id === undefined || submitObject.lead_education.program_id === null) {
        var program_field = this.formFields.filter((q) => q.name === 'program_id' && q.model === 'lead_education')
        if (program_field.length) {
          submitObject.lead_education.program_id = program_field[0].formListItems[0].id
        }
      }
      var finalRequest = { offer_ping: { raw_request: submitObject, consumer_id: this.consumerId, campaign_id: this.offer.campaignId } }
      if (this.offer.offerExternalInfoId) {
        finalRequest.offer_ping.offer_external_info_id = this.offer.offerExternalInfoId
      }

      var results = await PortalPostJson('external_offer_pings', finalRequest)

      if (!results.valid) {
        this.failedPing = true
      }

      this.showLoading = false
    },
    handleBeforeUnload (event) {
      event.preventDefault()
      event.returnValue = 'Are you sure you want to leave the portal?'
    }
  },
  mounted () {
    this.initModal()
    if (this.offer.formId) {
      this.getFormDetails()
    } else {
      this.processFormFields(this.offer.formFields, this.offer.formListItems)
    }
    if (this.offer.expiresAt) {
      var vue = this
      setInterval(() => { vue.currentTime = Date.now() }, 1000)
    }
    if (this.similarSubmitted) {
      this.skip('A similar offer has been submitted')
    }
    if (this.showIndex === 0 && !this.failedPing) {
      this.triggerPrePingCheck()
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  unmounted () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  watch: {
    similarSubmitted (val) {
      if (val) {
        this.skip('A similar offer has been submitted')
      }
    },
    showForm: function (val) {
      this.triggerPrePingCheck()
    },
    expired: function (val) {
      this.$emit('expired', { offerId: this.offer.id, displayedOfferId: this.offer.displayedOfferId })
    }
  }
}
</script>

<style scoped>
.row {
  margin-right: calc(var(--bs-gutter-x) * -1);
  margin-left: calc(var(--bs-gutter-x) * -1);
}
.offer.container {
  padding-top: 10px;
  border: 1px solid #dee2e6;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.offer.container.highlight {
  border: solid 3px #4cae4c
}
.offer-header {
  background-color: #d9edf7;
}
.priority_offer .offer-header{
  background-color: #d9f7db;
}
.offer-title {
  font-size: 18px;
  margin-top: 10px;
  color: rgb(51, 51, 51);
}
.skip-button, .show-button {
  font-size: 14px;
  max-height: 35px;
}
.offer-header .header-center {
  margin-top: 10px;
  margin-bottom: 10px;
}
.offer-header .button-area {
  margin-top: 5px;
  margin-bottom: 10px;
}
.aos-title {
  text-decoration: underline;
  font-weight: 700;
  font-size: 14px;
}
.aos-row {
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #dee2e6;
}
.btn.btn-primary {
  background-color: #337ab7;
  border-color: #2e6da4;
  font-size: 14px;
}
.offer-id-info {
  font-size: 12px;
  color: #6f6f6f;
}
.offer-logo {
  max-width: 100px;
}
.exclusive-logo{
  max-width: 100px;
  max-height: 55px;
  margin-top: -10px;
  margin-left: calc(var(--bs-gutter-x) / -2);
}
.small-top.row {
  padding-top: 5px;
}
.close-modal-x {
  float: right;
  cursor: pointer;
  font-weight: 800;
  font-size: 17px;
  margin-top: -15px;
  opacity: .35;
}
.close-modal-x:hover {
 opacity: .75;
}
.view-more {
  cursor: pointer;
  color: #337ab7;
}
.view-more:hover {
  color: #23527c;
  text-decoration: underline;
}
.first-submit, .second-submit {
  padding-top: 7px;
}
.warning-row {
  color: red;
  font-weight: 700;
  text-align: center;
  padding-bottom: 10px;
}
.deactivated .small-top.row {
  pointer-events: none;
  filter: grayscale(100%);
}
.deactivated .offer-form {
  pointer-events: none;
  filter: grayscale(100%);
}
.wt-header {
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: #6f6f6f solid 1px;
  border-bottom: #6f6f6f solid 1px;
}
.wt-header .bi-arrow-down {
  height: 45px;
}
.wt-title {
  font-size: 18px;
  font-weight: 500;
  padding-top: 10px;
}
</style>
<style>
.offer-form .field-label {
  text-align: right;
  font-weight: 700;
}
.offer-form .field-response {
  padding-top: 7px;
}
.offer .field-error {
  color: red;
  padding-top: 10px;
}
@media screen and (min-width: 1285px) {
  .offer-form .field-label {
    padding-top: 7px;
  }
}
</style>
